import { Theme, makeStyles } from '@forgeglobal/design-framework';

export const useStyles = makeStyles((theme: Theme) => ({
  box: {
    background: theme.palette.background.paper,
    '& .MuiTabs-root': {
      background: theme.palette.background.paper,
      paddingLeft: theme.spacing(0),
      [theme.breakpoints.up('md')]: {
        marginLeft: theme.spacing(-1.5),
      },
      [theme.breakpoints.down('md')]: {
        marginLeft: theme.spacing(1),
      },
    },
  },
  container: {
    display: 'block',
    backgroundColor: theme.palette.background.paper,
  },
  titleContainer: {
    maxWidth: 1280,
    margin: '0 auto',
    padding: theme.spacing(4, 4.5),
    background: theme.palette.background.paper,
  },
  accountsHeader: {
    maxWidth: 600,
  },
  firmName: {
    overflow: 'hidden',
  },
  item: {
    padding: theme.spacing(3, 2),
    display: 'flex',
    flexDirection: 'row',
    transition: theme.transitions.create('background'),
    '&:hover': {
      background: theme.palette.grey[50],
    },
    alignItems: 'center',
  },
  itemInFunction: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  displayAccountType: {
    paddingRight: theme.spacing(1),
  },
  accountNumber: {
    paddingRight: theme.spacing(2),
  },
  status: {
    background: '#EDDC86',
    borderRadius: theme.spacing(2),
    padding: theme.spacing(0.5, 1),
    fontSize: '12px',
    height: '20px',
  },
  selectedItem: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
}));
